import { Route, Routes } from 'react-router-dom';
import BenefitLayout from '../../layout/layouts/BenefitLayout';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import DiscoverPage from '../../Pages/Discover';
import DiscoverProductsPage from '../../Pages/Discover/ProductsPage';

export const DiscoverRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <BenefitLayout>
            <WithTabTitle title="Discover">
              <DiscoverPage />
            </WithTabTitle>
          </BenefitLayout>
        }
      />
      <Route
        path="/:discoverCategoryId"
        element={
          <BenefitLayout>
            <DiscoverProductsPage />
          </BenefitLayout>
        }
      />
      <Route
        path="/benefitsIn/:location"
        element={
          <BenefitLayout>
            <DiscoverProductsPage />
          </BenefitLayout>
        }
      />
    </Routes>
  );
};
